import React, { useEffect, useState } from 'react';
import { Alert, Spinner, Table } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import accountApi from '../../services/accountApi';

function TeamRolesPage() {
  const { activeTenantId } = useAuth();
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!activeTenantId) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await accountApi.getTenantRoleCatalog(activeTenantId);
        if (!cancelled) setCatalog(data);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load role catalog');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [activeTenantId]);

  return (
    <div>
      <h1 className="product-page-title">Team roles</h1>
      <p className="product-page-subtitle">
        Role definitions and permissions for this organization.
      </p>

      {error && <Alert variant="danger">{error}</Alert>}
      {loading && (
        <div className="loading-state">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading roles…
        </div>
      )}

      {!loading && catalog && (
        <>
          <div className="product-card mb-3">
            <p className="mb-0 small text-muted">
              Your role: <strong>{catalog.current_role || '—'}</strong>
              {catalog.assignable_roles && catalog.assignable_roles.length > 0 && (
                <>
                  {' '}
                  · You can assign: {catalog.assignable_roles.join(', ')}
                </>
              )}
            </p>
          </div>

          <div className="product-card">
            <Table responsive className="product-table" size="sm">
              <thead>
                <tr>
                  <th>Role</th>
                  <th>Description</th>
                  <th>Members</th>
                  <th>Permissions</th>
                </tr>
              </thead>
              <tbody>
                {(catalog.roles || []).map((role) => (
                  <tr key={role.code}>
                    <td>
                      <strong>{role.display_name || role.code}</strong>
                      <div className="text-muted small">{role.code}</div>
                    </td>
                    <td>{role.description || '—'}</td>
                    <td>{role.member_count ?? 0}</td>
                    <td>
                      <code className="small">{(role.permissions || []).join(', ')}</code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
}

export default TeamRolesPage;
